export enum DefaultState {
  EMPTY = 1,
  ALLOWED_SECTION_STATE = 1
}
